// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 735) return "static/chunks/735.7325ee05f63dd7ba.js";
	if (chunkId === 232) return "static/chunks/232.904d1280fb0299ca.js";
	if (chunkId === 253) return "static/chunks/253.4a122dc36f324be4.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"181":"91a8ef9007de9b43","313":"1f1f6dcf8b6432de","565":"4c4f6f74e6976d9c","790":"52596399774412d8"}[chunkId] + ".js";
};